<script>
  export let selectedIndex = 0;
  import { slashVisible, slashItems, slashProps } from './stores';
  
  let elements = [];
  
  // https://svelteboard.com/tutorials/svnotion
</script>
{#if $slashVisible}
  <div
    class="m-1 position-relative shadow-lg border border-primary"
    style="left: 0px; top: -3em; z-index: 100">
    {#each $slashItems as { title, subtitle, command }, i}
      <div
        class="p-2 cursor-pointer {i == selectedIndex ? 'bg-light' : 'bg-white'}"
        on:mouseenter={() => (selectedIndex = i)}
        on:click={() => {
          $slashVisible = false;
          command($slashProps);
        }}
        bind:this={elements[i]}
      >
        <div class="text-primary">{title}</div>
      </div>
    {/each}
  </div>
{/if}

